import { c as _c } from "react/compiler-runtime";
import { NavigationLink as LinkElement } from '@/components/Atoms/NavigationLink/NavigationLink';
import type { NavigationSection } from '@/contexts/NavigationContext/NavigationContext';
import { useNavigationContext } from '@/contexts/NavigationContext/NavigationContext';
import { getNavSectionId } from '@/contexts/NavigationContext/NavigationWrapper';
import type { KeyboardEvent, MouseEvent, UIEvent } from 'react';
export const NavigationLink = t0 => {
  const $ = _c(27);
  const {
    section,
    index
  } = t0;
  const {
    visibleHoverMenuIndex,
    openHoverMenu,
    closeMenu
  } = useNavigationContext();
  let ariaProps;
  let extraProps;
  if ($[0] !== closeMenu || $[1] !== index || $[2] !== openHoverMenu || $[3] !== section.title || $[4] !== visibleHoverMenuIndex) {
    extraProps = {} as {
      [key: string]: any;
    };
    let t1;
    if ($[7] !== index || $[8] !== openHoverMenu) {
      t1 = event => {
        openHoverMenu(index, event.currentTarget);
      };
      $[7] = index;
      $[8] = openHoverMenu;
      $[9] = t1;
    } else {
      t1 = $[9];
    }
    const showSubMenuHoverHandler = t1;
    let t2;
    if ($[10] !== closeMenu || $[11] !== index || $[12] !== openHoverMenu || $[13] !== visibleHoverMenuIndex) {
      t2 = event_0 => {
        event_0.preventDefault();
        if (visibleHoverMenuIndex === null || index !== visibleHoverMenuIndex) {
          openHoverMenu(index, event_0.currentTarget);
        } else {
          closeMenu();
        }
      };
      $[10] = closeMenu;
      $[11] = index;
      $[12] = openHoverMenu;
      $[13] = visibleHoverMenuIndex;
      $[14] = t2;
    } else {
      t2 = $[14];
    }
    const showSubMenuFocusHandler = t2;
    ariaProps = {};
    extraProps.onMouseEnter = showSubMenuHoverHandler;
    extraProps.onClick = showSubMenuFocusHandler;
    let t3;
    if ($[15] !== closeMenu) {
      t3 = event_1 => {
        if (event_1.key === "Escape") {
          closeMenu();
        }
      };
      $[15] = closeMenu;
      $[16] = t3;
    } else {
      t3 = $[16];
    }
    extraProps.onKeyDown = t3;
    ariaProps["aria-label"] = section.title;
    ariaProps["aria-expanded"] = visibleHoverMenuIndex === index;
    $[0] = closeMenu;
    $[1] = index;
    $[2] = openHoverMenu;
    $[3] = section.title;
    $[4] = visibleHoverMenuIndex;
    $[5] = ariaProps;
    $[6] = extraProps;
  } else {
    ariaProps = $[5];
    extraProps = $[6];
  }
  let t1;
  if ($[17] !== index) {
    t1 = getNavSectionId(index);
    $[17] = index;
    $[18] = t1;
  } else {
    t1 = $[18];
  }
  const t2 = `#${t1}`;
  const t3 = visibleHoverMenuIndex === index;
  let t4;
  if ($[19] !== section.title) {
    t4 = <span>{section.title}</span>;
    $[19] = section.title;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== ariaProps || $[22] !== extraProps || $[23] !== t2 || $[24] !== t3 || $[25] !== t4) {
    t5 = <LinkElement href={t2} $selected={t3} {...ariaProps} {...extraProps}>{t4}</LinkElement>;
    $[21] = ariaProps;
    $[22] = extraProps;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  return t5;
};